import React from 'react'
import { TextField, Paper } from '@mui/material'
import styled from 'styled-components'

const TextFieldTransparent = styled(TextField)`
    // for outlined input
    & fieldset {
        border: none;
    }
`;

export default function TextFieldPaper({ paperProps, ...props }) {
    return (
        <Paper {...paperProps}>
            <TextFieldTransparent {...props} />
        </Paper>
    )
}